import { render } from "./StringConfig.vue?vue&type=template&id=48a6be34&ts=true"
import script from "./StringConfig.vue?vue&type=script&lang=ts"
export * from "./StringConfig.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/soctio/singlepage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__